import { OverlayRef } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';

import { NavigationService } from '@frontend/vanilla/core';
import { AccountMenuComponent } from '@frontend/vanilla/shared/account-menu';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AccountMenuScrollService } from './account-menu-scroll.service';
import { INITIAL_ROUTE } from './account-menu-tokens';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AccountMenuComponent],
    selector: 'vn-account-menu-overlay',
    templateUrl: 'account-menu-view.html',
    host: {
        '(scroll)': 'onScroll($event)',
        'class': 'th-scroll',
    },
})
export class AccountMenuOverlayComponent implements OnInit, OnDestroy {
    private overlayRef = inject(OverlayRef);
    private navigationService = inject(NavigationService);
    private accountMenuScrollService = inject(AccountMenuScrollService);

    route: string;

    private unsubscribe = new Subject<void>();

    constructor() {
        const initialRoute = inject(INITIAL_ROUTE);

        this.route = initialRoute;
    }

    ngOnInit() {
        this.navigationService.locationChange.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.overlayRef.detach();
        });
    }

    onScroll(event: Event) {
        this.accountMenuScrollService.onScroll(event);
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
